export default function(environmentVariables) {
  return {
    client: environmentVariables.REACT_APP_CLIENT,
    project: environmentVariables.REACT_APP_PROJECT_NAME,
  };
};
